import React, { useCallback, useEffect } from 'react';

import { useCurrentUser } from 'Auth';

import { ChipsInput } from '@gogame/components';
import { withFormField } from '@gogame/form';
import { useMountedState } from '@gogame/hooks-ts';

import { loadUsers } from '../../source/subscriptions';

const Recipients = withFormField()(({ value, onChange, label, required }) => {
  const currentUser = useCurrentUser();

  const [usersList, setUsersList] = useMountedState(null);

  const loadUsersList = async () => {
    const response = await loadUsers();
    setUsersList(response);
  };

  useEffect(() => {
    loadUsersList();
  }, []);

  const handleSearchUsers = useCallback(
    ({ search }) => {
      return Promise.resolve(
        usersList?.filter(({ name, login, email }) => {
          const nameLowerCase = [name, login, email]
            .map((el) => el.toString())
            .join(' ');
          const searchLowerCase = search.toLowerCase();
          return nameLowerCase.includes(searchLowerCase);
        }) || []
      );
    },
    [usersList]
  );

  const isTagRemovable = (opt) => opt.id !== currentUser.id;

  const handleChange = (e, value) => {
    onChange(
      e,
      value.length
        ? value
        : [
            {
              id: currentUser.id,
              login: currentUser.login,
              name: currentUser.name,
              email: currentUser.userEmail,
            },
          ]
    );
  };

  return (
    <ChipsInput
      label={label}
      value={value}
      required={required}
      onSearch={handleSearchUsers}
      isTagRemovable={isTagRemovable}
      onChange={handleChange}
    />
  );
});

export default Recipients;
